import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component';
import { environment } from 'environments/environment';
@Injectable()
export class AuditTransactionSearchService extends ServiceBase {

    constructor(private _http: HttpClient) {
        super();
    }

    getAuditTransactionVisits = (filter: any): Observable<any> => {

        return this._http.post<any>(`${environment.queryModel}AuditTransactions/AuditTransactionVisits`, filter);
    }
    
    getAuditStatements = (filter: any): Observable<any> => {

        return this._http.post<any>(`${environment.queryModel}AuditTransactions/AuditStatements`, filter);
    }
    
    getAuditServices = (filter: any): Observable<any> => {

        return this._http.post<any>(`${environment.queryModel}AuditTransactions/AuditServices`, filter);
    }
}